module.exports = __webpack_public_path__ + "img/banner.effcfa0c.jpg";